import { useConfig } from '@browsing/config';
import { getCookie, isClient } from '@pegasus/utils';
export var usePlusExclusive = isClient() && getCookie('zl_plus_exclusive') === 'true'
    ? function () { return true; }
    : function () {
        var isConfigEnabled = useConfig().isEnabled('plus_exclusive');
        return isConfigEnabled || false;
    };
